// Biblioteca de templates para geração de posts Facebook e roteiros de vídeo.
// Todos os placeholders {ferramenta}, {beneficio}, {cta}, {url} são substituídos no generator.
// Módulo isolado — não altera nenhuma lógica existente.

export type Ferramenta = {
  key: string;
  nome: string;
  beneficio: string;
  url: string; // rota relativa
};

// ⭐ Ferramentas de JOGO DO BICHO (foco principal do conteúdo)
export const FERRAMENTAS_BICHO: Ferramenta[] = [
  // Métodos
  { key: "soma_chave_ouro", nome: "Soma Chave de Ouro", beneficio: "descubra o número quente do dia usando o código matemático 0663", url: "/metodos" },
  { key: "calculadora_chave_ouro", nome: "Calculadora Chave de Ouro", beneficio: "combine as chaves regionais (Rio 469 / SP 385) com 4 operações mágicas", url: "/metodos" },
  { key: "ia_bicho", nome: "Sistema IA Bicho", beneficio: "previsão baseada nas tendências de repetição dos últimos 6 sorteios", url: "/metodos" },
  { key: "achar_centena_dia", nome: "Achar Centena do Dia", beneficio: "encontre a centena mais provável para o próximo sorteio", url: "/metodos" },
  { key: "centena_matadora", nome: "Centena Matadora", beneficio: "3 centenas fortíssimas geradas por análise cruzada", url: "/metodos" },
  { key: "centenas_viciadas", nome: "Centenas Viciadas", beneficio: "descubra quais centenas estão repetindo nos resultados", url: "/metodos" },
  { key: "bio_numerico", nome: "Bio Numérico Stellar", beneficio: "seu número da sorte pelo seu mapa numerológico", url: "/metodos" },
  { key: "numerologia_nome", nome: "Numerologia do Nome", beneficio: "seu palpite pessoal calculado pelo seu nome completo", url: "/metodos" },
  { key: "metodo_777", nome: "Método 777", beneficio: "sequência triplicada que já premiou dezenas de apostadores", url: "/metodos" },
  { key: "cruz_dia", nome: "Método Cruz do Dia", beneficio: "cruze horizontal e vertical para achar a dezena certa", url: "/metodos" },
  { key: "sequencia", nome: "Método Sequência", beneficio: "identifica sequências ocultas nos últimos sorteios", url: "/metodos" },
  { key: "sete_grupos", nome: "Sete Grupos Dezenas", beneficio: "monte um jogo com os 7 grupos mais quentes", url: "/metodos" },
  { key: "esquema_infalivel", nome: "Esquema Infalível", beneficio: "esquema de fechamento que cobre múltiplos prêmios", url: "/metodos" },
  { key: "desdobramento_jb", nome: "Desdobramento JB", beneficio: "desdobre suas dezenas e aumente as chances", url: "/metodos" },
  { key: "soma_bahia", nome: "Soma Bahia", beneficio: "método regional da Bahia que vem acertando muito", url: "/metodos" },
  { key: "dezenas_premiadas", nome: "Dezenas Premiadas", beneficio: "as dezenas que mais saíram nos últimos 30 dias", url: "/metodos" },
  { key: "centena_bichos", nome: "Centena dos Bichos", beneficio: "centenas ligadas aos grupos que estão bombando", url: "/metodos" },

  // Ferramentas principais do bicho
  { key: "palpites_ia", nome: "Palpites IA", beneficio: "receba palpites gerados por inteligência artificial todos os dias", url: "/gerar-jogos" },
  { key: "estatisticas", nome: "Estatísticas", beneficio: "veja o que mais saiu, o que está atrasado e o que vai vir", url: "/estatisticas" },
  { key: "resultados", nome: "Resultados ao Vivo", beneficio: "todos os resultados do Jogo do Bicho em tempo real", url: "/resultados-bicho" },
  { key: "puxadas", nome: "Puxadas", beneficio: "gere puxadas automáticas a partir de qualquer resultado", url: "/puxadas" },
  { key: "software_turbinado", nome: "Software Turbinado", beneficio: "gera jogos combinando os últimos resultados do bicho", url: "/software" },
  { key: "guru_chat", nome: "Guru Chat IA", beneficio: "converse com a IA e receba palpites personalizados do bicho", url: "/guru-chat" },
  { key: "vitrine", nome: "Vitrine de Métodos", beneficio: "veja todos os métodos de Jogo do Bicho em um só lugar", url: "/vitrine" },

  // Institucional
  { key: "institucional", nome: "IA Palpite Guru", beneficio: "a plataforma mais completa de Jogo do Bicho do Brasil", url: "/" },
];

// 🎰 Ferramentas COMPLEMENTARES (Loterias Caixa — usadas com pouca frequência)
export const FERRAMENTAS_COMPLEMENTARES: Ferramenta[] = [
  { key: "loterias", nome: "Loterias Caixa", beneficio: "palpites para Mega, Lotofácil, Quina e mais — complementar ao bicho", url: "/loterias" },
];

// Combinado (para o seletor do painel admin) — bicho primeiro, complementares no final
export const FERRAMENTAS: Ferramenta[] = [...FERRAMENTAS_BICHO, ...FERRAMENTAS_COMPLEMENTARES];

export type PostTemplate = {
  id: string;
  copy: string; // usa {nome}, {beneficio}, {cta}, {url}
};

export const POSTS_FACEBOOK: PostTemplate[] = [
  {
    id: "p1",
    copy: `🎯 CANSADO de errar seus palpites do bicho?

Conheça o {nome} 👉 {beneficio}.

Mais de 2.000 apostadores já estão usando HOJE 🔥

Teste agora: {url}

#jogodobicho #palpitedodia #iapalpiteguru`,
  },
  {
    id: "p2",
    copy: `⚡ ATENÇÃO APOSTADOR DO BICHO!

O {nome} acaba de ser atualizado — {beneficio}.

Não perca o próximo sorteio do PT/PTM/PT2 👇
{url}

#bicho #resultadoaovivo #jogodobicho`,
  },
  {
    id: "p3",
    copy: `💰 QUEM ACOMPANHA O BICHO, ACERTA.

{nome}: {beneficio}.

+2000 apostadores já usaram esse método essa semana.
Bora entrar no time dos que acertam grupo, dezena e milhar?

{url}

#jogodobicho #dicadodia #palpitecerto`,
  },
  {
    id: "p4",
    copy: `🚨 ISSO VAI MUDAR SEU JOGO DO BICHO 🚨

{nome} → {beneficio}.

Simples, rápido, direto ao ponto.
Acesse agora e teste no próximo sorteio do Rio:
{url}`,
  },
  {
    id: "p5",
    copy: `Você sabia? 🤔

O {nome} usa {beneficio}.
Milhares de apostadores do bicho estão faturando com essa técnica AGORA.

👉 {url}

#palpitecerto #bicho #jogodobicho`,
  },
  {
    id: "p6",
    copy: `🔥 BOMBA DO DIA NO JOGO DO BICHO 🔥

Acaba de sair no {nome}: {beneficio}.

Corre pra conferir antes do próximo PT:
{url}`,
  },
  {
    id: "p7",
    copy: `PARE de jogar no chute no bicho! ✋

{nome} te entrega {beneficio} — sem enrolação, direto no grupo, dezena, centena e milhar.

Teste hoje: {url}

#jogodobicho #iapalpiteguru`,
  },
  {
    id: "p8",
    copy: `📊 DADOS DO BICHO NÃO MENTEM

{nome}: {beneficio}.
Baseado em análise real dos últimos 30 dias de sorteios (Rio, SP, Bahia, PE).

Confira: {url}`,
  },
  // ➕ Novos templates com foco de bicho
  {
    id: "p9",
    copy: `🐯 GRUPO QUENTE + DEZENA CERTA = ACERTO NO BICHO!

Com {nome} você {beneficio}.
Descubra qual grupo (01 a 25) tá com tudo pra sair no próximo sorteio.

👉 {url}

#jogodobicho #grupodobicho #bichodahora`,
  },
  {
    id: "p10",
    copy: `🎰 MILHAR PREMIADA — COMO ACHAR?

Muita gente aposta milhar no achismo… e perde.
Com {nome} você tem {beneficio} — milhar, centena e dezena calculadas pela IA.

Bora acertar de verdade: {url}

#milharpremiada #jogodobicho`,
  },
  {
    id: "p11",
    copy: `👀 DEU NO POSTE! Confira agora.

Enquanto você olha o resultado passado, o {nome} já tá {beneficio} pro PRÓXIMO sorteio.

⏰ Extração já já — aproveita: {url}

#deunoposte #jogodobicho #ptrio`,
  },
  {
    id: "p12",
    copy: `🐘 5 GRUPOS QUE MAIS SAÍRAM ESSA SEMANA

Nossa IA analisou todos os sorteios e o {nome} {beneficio}.
Você joga no achismo ou nos dados? 📈

Descubra os grupos quentes: {url}

#jogodobicho #estatisticabicho #iapalpiteguru`,
  },
  {
    id: "p13",
    copy: `💎 PALPITE DE OURO DO DIA

{nome} — {beneficio}.
Grupo, dezena, centena e milhar calculados por IA para o próximo PT do Rio de Janeiro.

🔗 {url}

#palpitedeouro #jogodobicho #bichoderio`,
  },
  {
    id: "p14",
    copy: `🎯 DE R$ 1 PODE VIRAR R$ 4.000 NO BICHO

Sim, é possível — mas só se você jogar no palpite CERTO.
{nome} {beneficio}. É a IA trabalhando pra você.

Testa aí: {url}

#milhardobicho #jogodobicho`,
  },
];

export type RoteiroTemplate = {
  id: string;
  formato: string; // "Reels 30s" etc
  script: string; // usa {nome}, {beneficio}, {cta}, {url}
};

export const ROTEIROS_VIDEO: RoteiroTemplate[] = [
  {
    id: "r1",
    formato: "Reels 30s vertical 9:16",
    script: `[0-3s] GANCHO (texto grande na tela): "Você joga no bicho e nunca ganha?"
[3-8s] PROBLEMA (rosto na câmera): "A maioria aposta no achismo. Erra, perde, repete."
[8-20s] SOLUÇÃO (screen recording do app): "Com o {nome}, você tem {beneficio}. Olha só como é simples..."
[20-27s] PROVA: "Mais de 2000 apostadores já estão usando."
[27-30s] CTA: "Link na bio 👉 {url}"

Trilha: batida acelerada / lo-fi.
Legendas: SIM, letras grandes.`,
  },
  {
    id: "r2",
    formato: "Shorts 30s",
    script: `[0-2s] GANCHO: "Segredo do bicho que ninguém te conta 🤫"
[2-10s] PROBLEMA: "Enquanto você aposta no palpite do vizinho, uma IA analisa MILHARES de resultados."
[10-22s] SOLUÇÃO: "{nome} → {beneficio}. Basta abrir o app."
[22-28s] URGÊNCIA: "Próximo sorteio já vem aí, corre 🏃"
[28-30s] CTA: "{url}"`,
  },
  {
    id: "r3",
    formato: "TikTok 40s",
    script: `[0-3s] Rosto na câmera: "Bora provar que o Jogo do Bicho tem lógica"
[3-12s] Mostra print de resultado real
[12-25s] Screen do {nome}: "{beneficio}"
[25-33s] Depoimento em texto: "Ganhei R$450 usando esse método - Carlos, RJ"
[33-40s] CTA + link: "Testa aí ó 👉 {url}"

Efeito: transição rápida a cada 3s.`,
  },
  {
    id: "r4",
    formato: "Reels 25s - Antes/Depois",
    script: `[0-4s] "ANTES do {nome}": apostador coçando a cabeça, olhando papel
[4-15s] "DEPOIS do {nome}": {beneficio}. Sorriso, tela do celular mostrando acerto
[15-22s] "Faça o mesmo hoje mesmo"
[22-25s] CTA piscando: "{url}"`,
  },
  {
    id: "r5",
    formato: "Story 15s",
    script: `[0-5s] Enquete: "Você acredita em método pro bicho? SIM / NÃO"
[5-12s] "Eu também não acreditava, até conhecer {nome} - {beneficio}"
[12-15s] Sticker link: {url}`,
  },

  // ➕ Roteiros DETALHADOS (cena a cena, câmera, texto na tela, trilha, corte)
  {
    id: "r6",
    formato: "Reels 45s DETALHADO - Storytelling Bicho",
    script: `🎬 ROTEIRO DETALHADO — REELS 45s VERTICAL 9:16

━━━━━━━━━━━━━━━━━━━━
CENA 1 — GANCHO (0-4s)
━━━━━━━━━━━━━━━━━━━━
Enquadramento: close no rosto, luz frontal quente
Câmera: fixa, olho na lente
Fala: "Eu descobri como acertar no bicho — e não é sorte."
Texto na tela: "COMO EU PAREI DE PERDER NO BICHO"
Trilha: batida tensa entrando (suspense, 90bpm)
Corte: hard cut

━━━━━━━━━━━━━━━━━━━━
CENA 2 — DOR (4-12s)
━━━━━━━━━━━━━━━━━━━━
Enquadramento: plano médio mostrando papel amassado com números
Câmera: leve tremida (handheld)
Fala: "Anos jogando no palpite do vizinho. Perdia toda semana."
Texto na tela: "R$ 50, R$ 100, R$ 200 no lixo…"
Trilha: mesma, sobe volume
Corte: transição por whip pan

━━━━━━━━━━━━━━━━━━━━
CENA 3 — DESCOBERTA (12-22s)
━━━━━━━━━━━━━━━━━━━━
Enquadramento: screen recording do app + face cam pequena no canto
Câmera: cursor mostrando {nome}
Fala: "Aí encontrei o {nome}. {beneficio}."
Texto na tela: "GRUPO • DEZENA • CENTENA • MILHAR"
Trilha: muda para batida animada
Corte: zoom in no botão

━━━━━━━━━━━━━━━━━━━━
CENA 4 — PROVA (22-32s)
━━━━━━━━━━━━━━━━━━━━
Enquadramento: print do resultado do PT + palpite acertado lado a lado
Câmera: fixa com zoom lento
Fala: "Semana passada acertei grupo E dezena. Olha o print."
Texto na tela: "✅ ACERTOU GRUPO 14 - CARNEIRO"
Trilha: pico da música, drop
Corte: flash branco

━━━━━━━━━━━━━━━━━━━━
CENA 5 — CTA (32-45s)
━━━━━━━━━━━━━━━━━━━━
Enquadramento: rosto sorrindo + celular na mão
Câmera: fixa
Fala: "Testa hoje. Link tá aqui embaixo."
Texto na tela GRANDE: "👉 {url}"
Trilha: batida contínua até o final
Corte final: freeze frame com CTA piscando

━━━━━━━━━━━━━━━━━━━━
🎵 TRILHA: Suspense Dourado (royalty-free)
📱 LEGENDAS: SIM, brancas com contorno preto, fonte grande
🎨 CORES: preto, dourado, vermelho para acertos
#jogodobicho #bicho #palpitedobicho #iapalpiteguru`,
  },
  {
    id: "r7",
    formato: "YouTube 60s DETALHADO - Tutorial Bicho",
    script: `🎬 ROTEIRO DETALHADO — YOUTUBE 60s VERTICAL OU HORIZONTAL

━━━━━━━━━━━━━━━━━━━━
CENA 1 — ABERTURA (0-5s)
━━━━━━━━━━━━━━━━━━━━
Enquadramento: apresentador em pé, fundo neutro
Câmera: plano americano
Fala: "Hoje eu vou te mostrar exatamente como usar o {nome} pra acertar no próximo sorteio do bicho."
Texto na tela: "TUTORIAL — {nome}"
Trilha: intro rápida (2s) + fundo suave
Corte: cut

━━━━━━━━━━━━━━━━━━━━
CENA 2 — CONTEXTO (5-15s)
━━━━━━━━━━━━━━━━━━━━
Enquadramento: screen recording da homepage IA Palpite Guru
Câmera: cursor navegando
Fala: "O IA Palpite Guru tem 25+ métodos de bicho. Hoje vamos focar em um: {nome} — {beneficio}."
Texto na tela: "25+ MÉTODOS EM UM SÓ APP"
Trilha: fundo instrumental
Corte: dissolve suave

━━━━━━━━━━━━━━━━━━━━
CENA 3 — TUTORIAL (15-40s)
━━━━━━━━━━━━━━━━━━━━
Enquadramento: screen recording zoom in nas telas do método
Câmera: passos numerados na tela
Fala: "Passo 1: abre o app. Passo 2: escolhe {nome}. Passo 3: veja o palpite gerado com grupo, dezena, centena e milhar."
Texto na tela: "1️⃣  2️⃣  3️⃣ (surgindo conforme fala)"
Trilha: fundo mantém
Corte: cortes rítmicos a cada passo

━━━━━━━━━━━━━━━━━━━━
CENA 4 — RESULTADO (40-52s)
━━━━━━━━━━━━━━━━━━━━
Enquadramento: comparativo palpite × resultado real do sorteio
Câmera: split screen
Fala: "Olha o resultado da semana passada usando esse mesmo método."
Texto na tela: "✅ ACERTOU"
Trilha: swell / build-up
Corte: pico + flash

━━━━━━━━━━━━━━━━━━━━
CENA 5 — CTA (52-60s)
━━━━━━━━━━━━━━━━━━━━
Enquadramento: rosto do apresentador
Câmera: close
Fala: "Bora testar? Link tá na descrição — {url}. E ative o sino pra não perder o próximo tutorial."
Texto na tela: "👉 {url}" + botão de sino animado
Trilha: outro sting curto
Corte final: freeze com CTA

━━━━━━━━━━━━━━━━━━━━
🎵 TRILHA: Energia Urbana (royalty-free)
📱 LEGENDAS: SIM
🎨 CORES: preto, amarelo dourado, branco
#tutorialbicho #jogodobicho #iapalpiteguru`,
  },
  {
    id: "r8",
    formato: "TikTok 30s DETALHADO - Prova Social",
    script: `🎬 ROTEIRO DETALHADO — TIKTOK 30s VERTICAL 9:16

━━━━━━━━━━━━━━━━━━━━
CENA 1 (0-3s) — GANCHO CHOCANTE
Enquadramento: close rosto, expressão surpresa
Fala: "3 mil reais na milhar com o {nome}. Olha só."
Texto na tela: "3.000 REAIS 💰"
Trilha: viral tiktok beat entrando
━━━━━━━━━━━━━━━━━━━━
CENA 2 (3-10s) — SCREENSHOT DEPOIMENTO
Enquadramento: print de mensagem WhatsApp real
Fala: "Esse é o Carlos, do Rio. Usou {nome}, {beneficio}."
Texto na tela: "DEPOIMENTO REAL"
Trilha: mesma
━━━━━━━━━━━━━━━━━━━━
CENA 3 (10-22s) — DEMONSTRAÇÃO
Enquadramento: screen recording rápido do método
Fala: "Funciona assim: abre, gera, aposta, ganha."
Texto na tela: "ABRE • GERA • APOSTA • GANHA"
Trilha: pico
━━━━━━━━━━━━━━━━━━━━
CENA 4 (22-30s) — CTA URGÊNCIA
Enquadramento: contagem regressiva na tela
Fala: "Próximo sorteio tá chegando. Corre no link."
Texto na tela: "⏰ {url}"
━━━━━━━━━━━━━━━━━━━━
🎵 TRILHA: Vitória (royalty-free, orquestral)
📱 LEGENDAS: OBRIGATÓRIAS
#jogodobicho #ganhoubicho #iapalpiteguru`,
  },
];

// Templates institucionais extras (sem substituição de ferramenta)
export const POSTS_INSTITUCIONAIS: PostTemplate[] = [
  {
    id: "i1",
    copy: `🏆 IA PALPITE GURU — o app definitivo do Jogo do Bicho

+ 25 métodos de bicho (Soma Ouro, Cruz do Dia, IA Bicho, Método 777…)
+ Palpites IA todo dia
+ Estatísticas em tempo real
+ Resultados do PT, PTM, PT2, PT3, PT4 ao vivo
+ Puxadas automáticas
+ Suporte via WhatsApp
+ Sem enrolação

Comece agora: {url}

#jogodobicho #iapalpiteguru`,
  },
  {
    id: "i2",
    copy: `Por que apostadores sérios do bicho usam o IA Palpite Guru? 🤔

✅ Palpites de bicho gerados por IA
✅ Estatísticas em tempo real (grupo, dezena, centena, milhar)
✅ 25+ métodos profissionais
✅ Resultados do Jogo do Bicho ao vivo
✅ Novo Guru Chat: converse com a IA

Acesse: {url}`,
  },
];

/* =========================================================================
   ROTEIROS NARRADOS (~5 minutos) — texto corrido para locução.
   Sem marcações de cena, sem timestamps, sem emojis, sem rótulos de bloco.
   Placeholders: {nome}, {beneficio}, {url}
   ========================================================================= */

export type BlocoNarrado = { id: string; texto: string };

export const NARRACAO_ABERTURA: BlocoNarrado[] = [
  {
    id: "ab1",
    texto: `Se você joga no bicho e está cansado de apostar no chute, presta atenção nos próximos minutos, porque hoje eu vou te mostrar exatamente como funciona a ferramenta {nome}, aqui dentro do IA Palpite Guru. Eu vou explicar o que ela faz, como ela pensa, como você usa na prática e, principalmente, como transformar isso num jogo bem montado para a próxima corrida. Nada de teoria complicada, nada de promessa mirabolante. É estratégia, é número e é organização.`,
  },
  {
    id: "ab2",
    texto: `Todo apostador de jogo do bicho já passou por aquela sensação de olhar o resultado e pensar: eu quase acertei. Quase acertei o grupo, quase acertei a dezena, quase peguei a centena. E o quase, no bicho, não paga. Foi exatamente por isso que a gente criou a ferramenta {nome} dentro do IA Palpite Guru, e é ela que eu vou destrinchar com você agora, do começo ao fim.`,
  },
  {
    id: "ab3",
    texto: `Existe uma diferença gigante entre apostar por palpite de cabeça e apostar com base em dados. Quem aposta de cabeça repete os mesmos números por meses. Quem aposta com dados enxerga o que está quente, o que está atrasado e o que costuma vir junto. A ferramenta {nome}, do IA Palpite Guru, foi feita justamente para colocar esses dados na palma da sua mão em poucos segundos, e é isso que eu vou te mostrar neste vídeo.`,
  },
];

export const NARRACAO_EXPLICACAO: BlocoNarrado[] = [
  {
    id: "ex1",
    texto: `Vamos começar pelo básico. A proposta da ferramenta {nome} é simples de entender: {beneficio}. Ou seja, em vez de você abrir caderno, anotar resultado, somar na mão e ainda correr o risco de errar uma conta, o sistema faz esse trabalho pesado por você. Ele lê os resultados, organiza tudo em tabela, cruza as informações e devolve um caminho pronto para você montar o seu jogo. O que antes levava uma hora, agora leva menos de um minuto.`,
  },
  {
    id: "ex2",
    texto: `A lógica por trás disso é a mesma que qualquer apostador experiente usa, só que feita em escala. O apostador experiente olha os últimos resultados e percebe que um grupo está saindo demais, que uma dezena sumiu faz tempo, que uma centena está martelando. O problema é que a cabeça humana consegue guardar poucos resultados. O sistema guarda centenas. A ferramenta {nome} faz isso: {beneficio}. É a sua experiência multiplicada por um computador que não esquece nada.`,
  },
  {
    id: "ex3",
    texto: `Muita gente pergunta se isso é adivinhação. Não é, e eu quero ser bem honesto com você aqui. Ninguém adivinha resultado de sorteio. O que a gente faz é trabalhar com probabilidade e com comportamento de números. Existem grupos que estão em alta, existem dezenas que passam vinte, trinta sorteios sem aparecer, existem combinações que se repetem em determinados dias da semana. A ferramenta {nome} pega esse comportamento e organiza para você. {beneficio}. A decisão final continua sendo sua, mas agora ela é uma decisão informada.`,
  },
];

export const NARRACAO_PASSO_A_PASSO: BlocoNarrado[] = [
  {
    id: "pp1",
    texto: `Agora vamos para a parte prática, o passo a passo de como usar. Primeiro você entra na plataforma e abre a ferramenta {nome}. A tela é limpa, feita para quem joga no bicho de verdade, sem menu confuso. Segundo, você escolhe a base do que quer analisar: pode ser o resultado do Paratodos do Rio, pode ser a Federal, pode ser uma corrida específica do dia, como o PPT, o PT ou o da noite. Terceiro, você define o que quer olhar: grupo, dezena, centena, milhar, duque ou terno. Quarto, você manda gerar. Em segundos o sistema devolve a análise pronta na tela, com os números destacados, os mais quentes de um lado e os mais atrasados do outro. Quinto, e esse é o passo que separa quem ganha de quem só joga, você anota, monta o jogo e guarda o registro para conferir depois.`,
  },
  {
    id: "pp2",
    texto: `Na prática funciona assim. Você abre a ferramenta, seleciona a loteria que costuma jogar, escolhe as corridas que quer considerar e aperta o botão de gerar. O sistema roda a análise em cima dos resultados já cadastrados e mostra o retorno organizado. Aí você olha o que apareceu, escolhe os números que fazem sentido para o seu bolso e monta a aposta. Uma dica importante: não jogue tudo de uma vez. Divida o valor, cubra mais de uma possibilidade e mantenha constância. Apostador que se organiza dura mais, e quem dura mais tem mais chance de pegar o prêmio grande.`,
  },
];

export const NARRACAO_EXEMPLO: BlocoNarrado[] = [
  {
    id: "e1",
    texto: `Deixa eu te dar um exemplo bem concreto para ficar claro. Imagine que a ferramenta apontou o grupo dez, que é o coelho, com dezenas trinta e sete, trinta e oito, trinta e nove e quarenta. Você olha o histórico e percebe que a dezena trinta e nove não sai faz dezoito sorteios, enquanto o grupo dez apareceu três vezes nas últimas duas semanas. Isso é um sinal forte: grupo em alta e dezena atrasada dentro do mesmo grupo. A partir daí você monta o jogo. Pode jogar o grupo dez no primeiro prêmio, pode jogar a dezena trinta e nove do primeiro ao quinto, e ainda pode fechar duas ou três centenas em cima dessa dezena, por exemplo, cento e trinta e nove, quinhentos e trinta e nove e oitocentos e trinta e nove. Está vendo? Sai do achismo e vira um plano.`,
  },
  {
    id: "e2",
    texto: `Vou te dar outro exemplo prático, agora com milhar. Suponha que a análise mostrou que a dezena vinte e três vem repetindo nas corridas da tarde. Em cima disso você monta milhares terminando em vinte e três, variando a frente: mil e vinte e três, dois mil trezentos e vinte e três, quatro mil quinhentos e vinte e três. Você não precisa jogar dez milhares. Escolhe três ou quatro, aposta um valor que caiba no seu bolso e ainda garante o grupo correspondente como proteção. Esse é o tipo de montagem que a ferramenta {nome} te ajuda a fazer em segundos, e que na mão levaria muito tempo e muito papel.`,
  },
];

export const NARRACAO_PROVA: BlocoNarrado[] = [
  {
    id: "pr1",
    texto: `E por que isso funciona melhor do que apostar de cabeça? Porque elimina três erros clássicos do apostador. O primeiro erro é a repetição cega, aquele número que você joga há anos só por costume. O segundo erro é a memória curta, quando você jura que uma dezena saiu semana passada e na verdade ela não sai faz um mês. O terceiro erro é a falta de registro, que é apostar e nunca conferir se a estratégia deu certo. Com a ferramenta na mão, os três erros somem de uma vez, porque tudo fica escrito, organizado e conferível.`,
  },
  {
    id: "pr2",
    texto: `Dentro da plataforma você ainda tem muito mais do que essa ferramenta. Tem os resultados do jogo do bicho atualizados, tem as estatísticas completas de grupo, dezena, centena e milhar, tem mais de vinte métodos clássicos que os apostadores antigos usam, tem gerador de palpites com inteligência artificial e tem o Guru Chat, que é uma inteligência artificial especializada em jogo do bicho com quem você conversa como se estivesse falando com um apostador veterano. Você pergunta, ele responde, sugere números e explica o raciocínio.`,
  },
];

export const NARRACAO_FECHAMENTO: BlocoNarrado[] = [
  {
    id: "f1",
    texto: `Então o combinado é o seguinte. Use a ferramenta antes de cada corrida, monte o seu jogo com calma, jogue apenas o valor que você pode perder sem apertar o orçamento, e mantenha o registro de tudo. Jogo do bicho é entretenimento, não é fonte de renda garantida, e nenhum sistema no mundo garante resultado. O que a gente garante é organização, informação e uma base muito melhor do que o palpite solto. Para acessar, é só entrar em {url}. Se este vídeo te ajudou, deixa o like, se inscreve no canal e ativa o sininho, porque todo dia tem palpite novo, análise nova e ferramenta nova aqui. Um abraço e boa sorte na próxima corrida.`,
  },
  {
    id: "f2",
    texto: `Para fechar: teste a ferramenta {nome} hoje mesmo, na próxima corrida. Não precisa apostar alto, aposta o mínimo só para acompanhar o comportamento e ver com os próprios olhos como a análise se comporta. Depois volta aqui nos comentários e me conta o resultado, porque eu leio todos. O acesso está no link {url}, e lá dentro você também encontra o Guru Chat para tirar qualquer dúvida a qualquer hora. Lembrando sempre: jogue com responsabilidade, jogue por diversão e nunca comprometa o dinheiro das suas contas. Deixa o like, se inscreve no canal e até o próximo vídeo.`,
  },
];
